module.exports = __webpack_public_path__ + "img/approved.a267fa18.svg";